module.exports = __webpack_public_path__ + "img/ninguno-nadie.f95ffb03.png";